import alt from "../alt";

class ContactActions {
	sendEmail({ fullName, email, message, phone }) {
		return dispatch => {
			dispatch();

			fetch("/api/mailer", {
				method: "POST",
				headers: {
					"content-type": "application/json"
				},
				body: JSON.stringify({ fullName, email, message, phone })
			})
				.then(resp => resp.json())
				.then(json => {
					// console.log('got email resp', json);

					if (json.email === "sent") this.onSuccess(json);
					if (json.email === "error") this.onError(json);
				});
		};
	}

	onSuccess(json) {
		return json;
	}

	onError(json) {
		return json;
	}
}

module.exports = alt.createActions(ContactActions);
